import { Currency } from "../shared";
import { StoreProductGroupId, StoreProductId } from "../store/identifiers";
import { Match, Schema as S } from "effect";
export const Recurring = S.Struct({
    interval: S.Union(S.Literal("day"), S.Literal("week"), S.Literal("month"), S.Literal("year")),
    intervalCount: S.Number
});
export const Price = S.Struct({
    currency: Currency.Code.ISO4217.Schema,
    unitAmount: S.Union(S.Number, S.Null)
});
export class Schema extends S.Class("@open-revenue/S/store/Product")({
    object: S.Literal("or_store_product").pipe(S.propertySignature, S.withConstructorDefault(()=>"or_store_product")),
    /**
   * This could represent the "subscription group", "product", or "prices"
   */ id: StoreProductId.Schema,
    productGroupId: StoreProductGroupId.Schema,
    type: S.Union(S.Literal("one_time"), S.Literal("recurring")),
    name: S.String.pipe(S.NullishOr),
    description: S.String.pipe(S.NullOr),
    price: Price,
    // Recurring
    recurring: S.NullOr(Recurring),
    trialPeriod: S.NullOr(Recurring),
    active: S.Boolean
}) {
}
export const NormalizedDayPeriod = S.Int;
export const NormalizedDayPeriodFromInterval = S.transform(Recurring, NormalizedDayPeriod, {
    encode: (x)=>({
            interval: "day",
            intervalCount: x
        }),
    decode: (x)=>{
        const intervalDays = Match.value(x.interval).pipe(Match.when("day", ()=>1), Match.when("week", ()=>7), Match.when("month", ()=>30), Match.when("year", ()=>365), Match.exhaustive);
        return Math.round(x.intervalCount * intervalDays);
    },
    strict: false
});
